import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { DEFAULT_GRADIENT, DEFAULT_GRADIENT_HOVER } from "../../constants/theme";
import useTranslation from "../../customHooks/translations";

const Error401View = () => {
  const translation = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0d1b2a 0%, #0d3d2e 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        textAlign: 'center',
      }}
    >
      <LockPersonIcon sx={{ fontSize: { xs: 80, sm: 110 }, color: 'rgba(255,255,255,0.08)', mb: 3 }} />

      <Typography
        variant="h1"
        sx={{
          fontWeight: 900,
          fontSize: { xs: '6rem', sm: '9rem' },
          lineHeight: 1,
          background: DEFAULT_GRADIENT,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          mb: 1,
        }}
      >
        401
      </Typography>

      <Typography
        variant="h5"
        sx={{ color: 'white', fontWeight: 700, mb: 1.5, fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
      >
        Unauthorized
      </Typography>

      <Typography
        sx={{ color: 'rgba(255,255,255,0.5)', mb: 4, maxWidth: 380, fontSize: 15 }}
      >
        {translation.errors.error401Message}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/login')}
          sx={{
            background: DEFAULT_GRADIENT,
            color: 'white',
            fontWeight: 700,
            borderRadius: 2,
            px: 4,
            '&:hover': { background: DEFAULT_GRADIENT_HOVER },
            '&:focus': { outline: 'none' },
          }}
        >
          Log in
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate('/freak')}
          sx={{
            borderColor: 'rgba(255,255,255,0.25)',
            color: 'rgba(255,255,255,0.7)',
            fontWeight: 700,
            borderRadius: 2,
            px: 4,
            '&:hover': { borderColor: 'rgba(255,255,255,0.5)', color: 'white' },
            '&:focus': { outline: 'none' },
          }}
        >
          Go Home
        </Button>
      </Box>
    </Box>
  );
};

export default Error401View;
